<template>
    <tile style="grid-area: numbers-1" class="relative">
        <div class="flex flex-col gap-2 h-full">
            <account-link account-no="1920" class="text-lg text-primary">1920 {{ account?.name }}</account-link>
            <div class="flex items-baseline gap-2">
                <span class="text-2xl">{{ formatCurrency(accountBalance, 0) }}</span>
                <span class="text-normal opacity-60">NOK</span>
            </div>
            <pre v-if="false">{{ bankAccount }}</pre>
        </div>
    </tile>
</template>

<script setup lang="ts">
import Tile from '@/dashboard/Tile.vue'
import {formatCurrency} from '@/services/formatter.service'
import AccountLink from '@/bookkeeping-account/AccountLink.vue'
import {computed, onMounted, onUnmounted, ref} from 'vue'
import {findBankAccountByAccountNo} from '@/bank/bank-account.service'
import {getGeneralLedger} from '@/genleg/ledger.service'
import {format} from 'date-fns'
import {ORG_SWITCHED} from '@/types/events'
import {TRANSACTION_CREATED} from '@/types/transaction/TransactionEvent'
import {useEmitter} from '@/services/infrastructure/emitter'
import {findAccountByNo} from '@/bookkeeping-account/bookkeepingAccount.service'
const {onEvents, cleanUp} = useEmitter()

const props = defineProps({
    accountNo: {
        type: String,
        default: '1920'
    }
})

const bankAccount = computed(() => findBankAccountByAccountNo(props.accountNo))
const account = computed(() => findAccountByNo(props.accountNo))
const accountBalance = ref(0)

const fetchAccountLedger = async () => {
    const date = format(new Date(), 'yyyy-MM-dd')
    const ledger = await getGeneralLedger({accountNo: props.accountNo, fromDate: date, toDate: date})
    const account = ledger?.ledgerAccounts.find(acc => acc.accountNo === props.accountNo)
    accountBalance.value = account?.outgoingBalance || 0
}
onMounted(fetchAccountLedger)
onEvents([ORG_SWITCHED, TRANSACTION_CREATED], fetchAccountLedger)
onUnmounted(cleanUp)
</script>

<style>

</style>
